module.exports = __webpack_public_path__ + "img/promo-bg.0ba831e.jpg";